module.exports = __webpack_public_path__ + "img/logo-light.0e133fdd.png";